export const delivery_new_lsp = {
    companyTable: {
        pageId: 'legal-perform-lsp17',
        searchId: 'legal-perform-lsp17-sd',
        leftOperation: true,
        leftWidth: 200,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            {
                label: '两月是否连续C',
                prop: 'twoMonthsContinuousC',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '150px',
            },
            // {
            //     label: '两月是否连续D',
            //     prop: 'twoMonthsContinuousD',
            //     type: 'select',
            //     options: [
            //         { label: '否', value: '1' },
            //         { label: '是', value: '2' },
            //     ],
            //     width: '150px',
            // },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                'label': '罚扣金额',
                'prop': 'penaltyDeductionAmount',
                'width': '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '申诉期截止时间',
                prop: 'appealDeadlingTime',
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/lsrm/legalPerform-30',
            },
            {
                type: 'text',
                label: '确认绩效',
                size: 'small',
                event: 'confirmPerform',
                ifHas: '/lsrm/legalPerform-10',
            },
            {
                type: 'text',
                label: '申诉',
                size: 'small',
                event: 'appeal',
                ifHas: '/lsrm/legalPerform-20',
            },
        ],
    },
    companyClientTable: {
        pageId: 'legal-perform-lsp18',
        searchId: 'legal-perform-lsp18-sd',
        leftOperation: true,
        leftWidth: 200,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                label: '内外部客户',
                prop: 'customerType',
                type: 'select',
                options: [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '申诉期截止时间',
                prop: 'appealDeadlingTime',
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/lsrm/legalPerform-30',
            },
            {
                type: 'text',
                label: '确认绩效',
                size: 'small',
                event: 'confirmPerform',
                ifHas: '/lsrm/legalPerform-10',
            },
            {
                type: 'text',
                label: '申诉',
                size: 'small',
                event: 'appeal',
                ifHas: '/lsrm/legalPerform-20',
            },
        ],
    },
    businessTable: {
        pageId: 'legal-perform-lsp19',
        searchId: 'legal-perform-lsp19-sd',
        leftOperation: true,
        leftWidth: 200,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            {
                label: '两月是否连续C',
                prop: 'twoMonthsContinuousC',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '150px',
            },
            // {
            //     label: '两月是否连续D',
            //     prop: 'twoMonthsContinuousD',
            //     type: 'select',
            //     options: [
            //         { label: '否', value: '1' },
            //         { label: '是', value: '2' },
            //     ],
            //     width: '150px',
            // },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                'label': '罚扣金额',
                'prop': 'penaltyDeductionAmount',
                'width': '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '申诉期截止时间',
                prop: 'appealDeadlingTime',
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/lsrm/legalPerform-30',
            },
            {
                type: 'text',
                label: '确认绩效',
                size: 'small',
                event: 'confirmPerform',
                ifHas: '/lsrm/legalPerform-10',
            },
            {
                type: 'text',
                label: '申诉',
                size: 'small',
                event: 'appeal',
                ifHas: '/lsrm/legalPerform-20',
            },
        ],
    },
    businessClientTable: {
        pageId: 'legal-perform-lsp20',
        searchId: 'legal-perform-lsp20-sd',
        leftOperation: true,
        leftWidth: 200,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                label: '内外部客户',
                prop: 'customerType',
                type: 'select',
                options: [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '申诉期截止时间',
                prop: 'appealDeadlingTime',
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/lsrm/legalPerform-30',
            },
            {
                type: 'text',
                label: '确认绩效',
                size: 'small',
                event: 'confirmPerform',
                ifHas: '/lsrm/legalPerform-10',
            },
            {
                type: 'text',
                label: '申诉',
                size: 'small',
                event: 'appeal',
                ifHas: '/lsrm/legalPerform-20',
            },
        ],
    },
    platformTable: {
        pageId: 'legal-perform-lsp21',
        searchId: 'legal-perform-lsp21-sd',
        leftOperation: true,
        leftWidth: 200,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                prop: 'siteName',
                label: '服务平台',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '申诉期截止时间',
                prop: 'appealDeadlingTime',
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/lsrm/legalPerform-30',
            },
            {
                type: 'text',
                label: '确认绩效',
                size: 'small',
                event: 'confirmPerform',
                ifHas: '/lsrm/legalPerform-10',
            },
            {
                type: 'text',
                label: '申诉',
                size: 'small',
                event: 'appeal',
                ifHas: '/lsrm/legalPerform-20',
            },
        ],
    },
    clientTable: {
        pageId: 'legal-perform-lsp22',
        searchId: 'legal-perform-lsp22-sd',
        leftOperation: true,
        leftWidth: 200,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                prop: 'siteName',
                label: '服务平台',
                width: '150px',
            },
            {
                label: '内外部客户',
                prop: 'customerType',
                type: 'select',
                options: [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '申诉期截止时间',
                prop: 'appealDeadlingTime',
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/lsrm/legalPerform-30',
            },
            {
                type: 'text',
                label: '确认绩效',
                size: 'small',
                event: 'confirmPerform',
                ifHas: '/lsrm/legalPerform-10',
            },
            {
                type: 'text',
                label: '申诉',
                size: 'small',
                event: 'appeal',
                ifHas: '/lsrm/legalPerform-20',
            },
        ],
    },
}

export const delivery_new_lsrm = {
    companyTable: {
        pageId: 'legal-perform-lsrm13',
        searchId: 'legal-perform-lsrm13-sd',
        leftOperation: true,
        leftWidth: 250,
        selectBtn: true,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '全国排名',
                prop: 'ranking',
                width: '120px',
                info: '分公司层级下，全国供应商绩效排名',
            },
            {
                label: '分公司内部排名',
                prop: 'internalRanking',
                width: '150px',
                info: '分公司绩效层级下，指该供应商当月绩效得分，在其所属分公司中所有供应商的排名',
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            {
                label: '两月是否连续C',
                prop: 'twoMonthsContinuousC',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '150px',
            },
            // {
            //     label: '两月是否连续D',
            //     prop: 'twoMonthsContinuousD',
            //     type: 'select',
            //     options: [
            //         { label: '否', value: '1' },
            //         { label: '是', value: '2' },
            //     ],
            //     width: '150px',
            // },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                'label': '罚扣金额',
                'prop': 'penaltyDeductionAmount',
                'width': '120px',
            },
            {
                label: '发文链接',
                prop: 'postingLink',
                width: '120px',
                type: 'link',
            },
            {
                label: '帮扶计划提交',
                prop: 'isSubmitHelpPlan',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'small',
                event: 'performChange',
                ifHas: '/legalPerform-10',
            },
            {
                type: 'text',
                label: '驳回申诉',
                size: 'small',
                event: 'rejectAppeal',
                ifHas: '/legalPerform-20',
            },
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/legalPerform-30',
            },
            {
                type: 'text',
                label: '查看帮扶计划',
                size: 'small',
                event: 'viewProject',
                ifHas: '/legalPerform-40',
            },
            {
                type: 'text',
                label: '提交帮扶计划',
                size: 'small',
                event: 'submitProject',
                ifHas: '/legalPerform-50',
            },
            // {
            //     'type': 'text',
            //     'label': '操作记录',
            //     'size': 'small',
            //     'event': 'record',
            //     'ifHas': '/legalPerform-110',
            // },
            {
                type: 'text',
                label: '审批',
                size: 'small',
                event: 'approve',
                ifHas: '/legalPerform-150',
            },
            {
                type: 'text',
                label: '详情',
                size: 'small',
                event: 'detail',
                ifHas: '/legalPerform-120',
            },
        ],
    },
    companyClientTable: {
        pageId: 'legal-perform-lsrm14',
        searchId: 'legal-perform-lsrm14-sd',
        leftOperation: true,
        leftWidth: 250,
        selectBtn: true,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                label: '内外部客户',
                prop: 'customerType',
                type: 'select',
                options: [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '全国排名(内外部)',
                prop: 'ranking',
                width: '170px',
                info: '分公司（内外部）层级下，全国供应商绩效排名，区分内部和外部客户两个维度',
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '发文链接',
                prop: 'postingLink',
                width: '120px',
                type: 'link',
            },
            {
                label: '帮扶计划提交',
                prop: 'isSubmitHelpPlan',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'small',
                event: 'performChange',
                ifHas: '/legalPerform-10',
            },
            {
                type: 'text',
                label: '驳回申诉',
                size: 'small',
                event: 'rejectAppeal',
                ifHas: '/legalPerform-20',
            },
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/legalPerform-30',
            },
            {
                type: 'text',
                label: '查看帮扶计划',
                size: 'small',
                event: 'viewProject',
                ifHas: '/legalPerform-40',
            },
            {
                type: 'text',
                label: '提交帮扶计划',
                size: 'small',
                event: 'submitProject',
                ifHas: '/legalPerform-50',
            },
            // {
            //     'type': 'text',
            //     'label': '操作记录',
            //     'size': 'small',
            //     'event': 'record',
            //     'ifHas': '/legalPerform-110',
            // },
            {
                type: 'text',
                label: '审批',
                size: 'small',
                event: 'approve',
                ifHas: '/legalPerform-150',
            },
            {
                type: 'text',
                label: '详情',
                size: 'small',
                event: 'detail',
                ifHas: '/legalPerform-120',
            },
        ],
    },
    businessTable: {
        pageId: 'legal-perform-lsrm15',
        searchId: 'legal-perform-lsrm15-sd',
        leftOperation: true,
        leftWidth: 250,
        selectBtn: true,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '经营中心排名',
                prop: 'ranking',
                width: '120px',
                info: '经营中心层级下，对在同一个经营中心下运作的供应商绩效进行排名',
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            {
                label: '两月是否连续C',
                prop: 'twoMonthsContinuousC',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '150px',
            },
            // {
            //     label: '两月是否连续D',
            //     prop: 'twoMonthsContinuousD',
            //     type: 'select',
            //     options: [
            //         { label: '否', value: '1' },
            //         { label: '是', value: '2' },
            //     ],
            //     width: '150px',
            // },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                'label': '罚扣金额',
                'prop': 'penaltyDeductionAmount',
                'width': '120px',
            },
            {
                label: '发文链接',
                prop: 'postingLink',
                width: '120px',
                type: 'link',
            },
            {
                label: '帮扶计划提交',
                prop: 'isSubmitHelpPlan',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'small',
                event: 'performChange',
                ifHas: '/legalPerform-10',
            },
            {
                type: 'text',
                label: '驳回申诉',
                size: 'small',
                event: 'rejectAppeal',
                ifHas: '/legalPerform-20',
            },
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/legalPerform-30',
            },
            {
                type: 'text',
                label: '查看帮扶计划',
                size: 'small',
                event: 'viewProject',
                ifHas: '/legalPerform-40',
            },
            {
                type: 'text',
                label: '提交帮扶计划',
                size: 'small',
                event: 'submitProject',
                ifHas: '/legalPerform-50',
            },
            // {
            //     'type': 'text',
            //     'label': '操作记录',
            //     'size': 'small',
            //     'event': 'record',
            //     'ifHas': '/legalPerform-110',
            // },
            {
                type: 'text',
                label: '审批',
                size: 'small',
                event: 'approve',
                ifHas: '/legalPerform-150',
            },
            {
                type: 'text',
                label: '详情',
                size: 'small',
                event: 'detail',
                ifHas: '/legalPerform-120',
            },
        ],
    },
    businessClientTable: {
        pageId: 'legal-perform-lsrm16',
        searchId: 'legal-perform-lsrm16-sd',
        leftOperation: true,
        leftWidth: 250,
        selectBtn: true,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                label: '内外部客户',
                prop: 'customerType',
                type: 'select',
                options: [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '经营中心排名(内外部)',
                prop: 'ranking',
                width: '170px',
                info: '经营中心（内外部）层级下，对在同一个经营中心运作的供应商绩效进行排名，排名区分内部和外部客户',
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '发文链接',
                prop: 'postingLink',
                width: '120px',
                type: 'link',
            },
            {
                label: '帮扶计划提交',
                prop: 'isSubmitHelpPlan',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'small',
                event: 'performChange',
                ifHas: '/legalPerform-10',
            },
            {
                type: 'text',
                label: '驳回申诉',
                size: 'small',
                event: 'rejectAppeal',
                ifHas: '/legalPerform-20',
            },
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/legalPerform-30',
            },
            {
                type: 'text',
                label: '查看帮扶计划',
                size: 'small',
                event: 'viewProject',
                ifHas: '/legalPerform-40',
            },
            {
                type: 'text',
                label: '提交帮扶计划',
                size: 'small',
                event: 'submitProject',
                ifHas: '/legalPerform-50',
            },
            // {
            //     'type': 'text',
            //     'label': '操作记录',
            //     'size': 'small',
            //     'event': 'record',
            //     'ifHas': '/legalPerform-110',
            // },
            {
                type: 'text',
                label: '审批',
                size: 'small',
                event: 'approve',
                ifHas: '/legalPerform-150',
            },
            {
                type: 'text',
                label: '详情',
                size: 'small',
                event: 'detail',
                ifHas: '/legalPerform-120',
            },
        ],
    },
    platformTable: {
        pageId: 'legal-perform-lsrm17',
        searchId: 'legal-perform-lsrm17-sd',
        leftOperation: true,
        leftWidth: 250,
        selectBtn: true,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                prop: 'siteName',
                label: '服务平台',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '分公司内排名',
                prop: 'ranking',
                width: '120px',
                info: '服务平台层级下，同一分公司供应商绩效排名',
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '发文链接',
                prop: 'postingLink',
                width: '120px',
                type: 'link',
            },
            {
                label: '帮扶计划提交',
                prop: 'isSubmitHelpPlan',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'small',
                event: 'performChange',
                ifHas: '/legalPerform-10',
            },
            {
                type: 'text',
                label: '驳回申诉',
                size: 'small',
                event: 'rejectAppeal',
                ifHas: '/legalPerform-20',
            },
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/legalPerform-30',
            },
            {
                type: 'text',
                label: '查看帮扶计划',
                size: 'small',
                event: 'viewProject',
                ifHas: '/legalPerform-40',
            },
            {
                type: 'text',
                label: '提交帮扶计划',
                size: 'small',
                event: 'submitProject',
                ifHas: '/legalPerform-50',
            },
            // {
            //     'type': 'text',
            //     'label': '操作记录',
            //     'size': 'small',
            //     'event': 'record',
            //     'ifHas': '/legalPerform-110',
            // },
            {
                type: 'text',
                label: '审批',
                size: 'small',
                event: 'approve',
            },
            {
                type: 'text',
                label: '详情',
                size: 'small',
                event: 'detail',
                ifHas: '/legalPerform-120',
            },
        ],
    },
    clientTable: {
        pageId: 'legal-perform-lsrm18',
        searchId: 'legal-perform-lsrm18-sd',
        leftOperation: true,
        leftWidth: 250,
        selectBtn: true,
        height: 'calc(100vh - 316px)',
        columns: [
            {
                label: '考核月份',
                prop: 'month',
                width: '80px',
            },
            {
                prop: 'companyName',
                label: '分公司',
                width: '150px',
            },
            {
                prop: 'businessCenterName',
                label: '经营中心',
                width: '150px',
            },
            {
                prop: 'siteName',
                label: '服务平台',
                width: '150px',
            },
            {
                label: '内外部客户',
                prop: 'customerType',
                type: 'select',
                options: [
                    { label: '内部客户', value: '1' },
                    { label: '外部客户', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '150px',
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: '80px',
                info: '<div>取该供应商创建时间是在当月的所有运输单计数求和。</div><div>专司限制：城配专司，城配专司-网络</div><div>取数来源：来自运输单基础表取tk单创建时间在当月的所有tk单数。</div>',
            },
            {
                label: '总得分',
                prop: 'countScore',
                width: '80px',
            },
            {
                label: '日度累计得分',
                prop: 'dailyCumulativeScore',
                width: '120px',
            },
            {
                label: '日度累计排名',
                prop: 'dailyCumulativeRanking',
                width: '120px',
                info: '每日更新当月1日到前一日的累计得分和排名',
            },
            {
                label: '日度绩效等级',
                prop: 'dailyPerformanceGrade',
                width: '120px',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
            },
            {
                label: '服务平台内排名',
                prop: 'ranking',
                width: '160px',
                info: '内外部客户层级下，同一服务平台供应商绩效排名，排名区分内部和外部客户',
            },
            {
                label: '回单上传及时率(%)',
                prop: 'receiptUploadRate',
                width: '160px',
                info: '<div>回单上传及时率=回单及时单量/应回单总单量*100%</div><div>回单及时单量：报表电子回单上传等于及时的所有TK单数求和</div><div>应回单总单量：取该供应商的要求回单上传时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-回单全链路监控汇总报表</div><div>数据银行-运营分析-订单品质-回单全链路明细报表</div>',
            },
            {
                label: '回单上传及时率得分',
                prop: 'receiptUploadRateScore',
                width: '140px',
            },
            {
                label: '应回单总单量',
                prop: 'receiptUploadAllCntTotal',
                width: '120px',
            },
            {
                label: '回单及时单量',
                prop: 'receiptUploadCntTotal',
                width: '120px',
            },
            {
                label: '配送及时率(%)',
                prop: 'deliveryTimelinessRate',
                width: '160px',
                info: '<div>配送及时率=当月及时签收的配送单量/当月应签收的配送单量*100%</div><div>当月及时签收的配送单量：报表配送是否及时等于及时的所有TK单数求和</div><div>当月应签收配送总单量：取该供应商要求配送时间在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>数据银行-运营分析-订单品质-配送及时率汇总</div><div>数据银行-运营分析-订单品质-配送及时率明细</div>',
            },
            {
                label: '配送及时率得分',
                prop: 'deliveryTimelinessRateScore',
                width: '120px',
            },
            {
                label: '当月应签收的配送单量',
                prop: 'deliveryAllCntTotal',
                width: '180px',
            },
            {
                label: '当月及时签收的配送单量',
                prop: 'deliveryCntTotal',
                width: '180px',
            },
            {
                label: '退货及时率(%)',
                prop: 'returnTimelinessRate',
                width: '160px',
                info: '<div>退货及时率=退货及时单量/应退回总单量*100%</div><div>退货及时单量：报表入库是否及时等于及时的所有TK单数求和</div><div>应退回总单量：取该供应商的要求入库时间是在当月的所有运输单计数求和。</div><div>专司限制：城配送装公司</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-物流-指标体系-同城配送-退货及时率</div><div>取数来源：数据银行-物流-指标体系-电商-电商退货入库及时率</div>',
            },
            {
                label: '退货及时率得分',
                prop: 'returnTimelinessRateScore',
                width: '120px',
            },
            {
                label: '应退回总单量',
                prop: 'returnAllCntTotal',
                width: '120px',
            },
            {
                label: '退货及时单量',
                prop: 'returnCntTotal',
                width: '120px',
            },
            {
                label: '破损率',
                prop: 'damageRate',
                width: '160px',
                info: '<div>破损率=（破损件数/经手件数)*1000000</div><div>破损件数：异常分类中所有打标破损的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '破损率得分',
                prop: 'damageRateScore',
                width: '120px',
            },
            {
                label: '破损件数',
                prop: 'damageAllCntTotal',
                width: '120px',
            },
            {
                label: '破损经手件数',
                prop: 'damageCntTotal',
                width: '120px',
            },
            {
                label: '遗失率',
                prop: 'lossRate',
                width: '160px',
                info: '<div>遗失率=（遗失件数/经手件数)*1000000</div><div>遗失件数：异常分类中所有打标遗失的件数</div><div>经手件数：开单计划承运件数</div><div>专司限制：城配送装公司</div><div>内部=菜鸟+内渠；外部=纯外部</div><div>采购渠道限制只取：车队供应商、快递公司、零担专线、物流公司、快递、临时专线</div><div>取数来源：数据银行-订单品质-遗失破损汇总表</div>',
            },
            {
                label: '遗失率得分',
                prop: 'lossRateScore',
                width: '120px',
            },
            {
                label: '遗失件数',
                prop: 'lostAllCntTotal',
                width: '120px',
            },
            {
                label: '遗失经手件数',
                prop: 'lostCntTotal',
                width: '120px',
            },
            {
                label: '减分项-客户投诉得分',
                prop: 'customerComplaintsScore',
                width: '150px',
            },
            {
                label: '加分项-客户表扬得分',
                prop: 'customerPraiseScore',
                width: '150px',
            },
            {
                label: '订单履约率（%）',
                prop: 'orderFulfillmentRate',
                width: '150px',
                info: '（配送+回单+退货）及时单量/(配送+回+退货）总单量',
            },
            // {
            //     label: '罚扣金额',
            //     prop: 'penaltyDeductionAmount',
            //     width: '150px',
            // },
            {
                label: '绩效等级',
                prop: 'performanceStarRating',
                type: 'select',
                optionNum: 'SUPPLIER_PERFORMANCE_STAR_RATING',
                options: [],
                width: '120px',
                info: '<div>根据已生效的绩效分划分：</div><div>A：X≥90</div><div>B：80≤X＜90</div><div>C：X＜80</div>',
            },
            {
                label: '是否申诉',
                prop: 'isAppeal',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
            {
                label: '绩效状态',
                prop: 'performanceStatus',
                type: 'select',
                optionNum: 'LEGAL_PERSON_PERFORMANCE',
                options: [],
                width: '120px',
                info: '<div>待推送供应商：系统生成绩效数据，待进行绩效调整和推送供应商</div><div>待供应商确认：绩效已推送供应商、或在复核后待供应商确认</div><div>待复核：供应商申诉、或绩效审批未通过，需复核</div><div>待审批：供应商已确认绩效、或申诉不通过，待提交审批</div><div>审批中：绩效已提交审批，审批中</div><div>绩效生效：绩效审批通过</div>',
            },
            {
                label: '发文链接',
                prop: 'postingLink',
                width: '120px',
                type: 'link',
            },
            {
                label: '帮扶计划提交',
                prop: 'isSubmitHelpPlan',
                type: 'select',
                options: [
                    { label: '否', value: '1' },
                    { label: '是', value: '2' },
                ],
                width: '120px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'small',
                event: 'performChange',
                ifHas: '/legalPerform-10',
            },
            {
                type: 'text',
                label: '驳回申诉',
                size: 'small',
                event: 'rejectAppeal',
                ifHas: '/legalPerform-20',
            },
            {
                type: 'text',
                label: '查看申诉',
                size: 'small',
                event: 'viewAppeal',
                ifHas: '/legalPerform-30',
            },
            {
                type: 'text',
                label: '查看帮扶计划',
                size: 'small',
                event: 'viewProject',
                ifHas: '/legalPerform-40',
            },
            {
                type: 'text',
                label: '提交帮扶计划',
                size: 'small',
                event: 'submitProject',
                ifHas: '/legalPerform-50',
            },
            // {
            //     'type': 'text',
            //     'label': '操作记录',
            //     'size': 'small',
            //     'event': 'record',
            //     'ifHas': '/legalPerform-110',
            // },
            {
                type: 'text',
                label: '审批',
                size: 'small',
                event: 'approve',
            },
            {
                type: 'text',
                label: '详情',
                size: 'small',
                event: 'detail',
                ifHas: '/legalPerform-120',
            },
        ],
    },
}

export const delivery_newSearch = {
    searchTxt: [
        {
            name: '承运商类别',
            value: 'transType',
            type: 'select',
            unfold: true,
            optionNum: 'SRM_SHIPPER_TYPE',
            options: [],
            span: 3,
        },
        {
            name: '是否连续两月A',
            value: 'twoMonthsContinuousA',
            type: 'select',
            unfold: true,
            options: [
                { label: '否', value: '1' },
                { label: '是', value: '2' },
            ],
            span: 3,
            visible: '1,6',
        },
        {
            name: '是否连续两月B',
            value: 'twoMonthsContinuousB',
            type: 'select',
            unfold: true,
            options: [
                { label: '否', value: '1' },
                { label: '是', value: '2' },
            ],
            span: 3,
            visible: '1,6',
        },
        {
            name: '是否连续两月C',
            value: 'twoMonthsContinuousC',
            type: 'select',
            unfold: true,
            options: [
                { label: '否', value: '1' },
                { label: '是', value: '2' },
            ],
            span: 3,
            visible: '1,6',
        },
        // {
        //     name: '是否连续两月D',
        //     value: 'twoMonthsContinuousD',
        //     type: 'select',
        //     unfold: true,
        //     options: [
        //         { label: '否', value: '1' },
        //         { label: '是', value: '2' },
        //     ],
        //     span: 3,
        //     visible: '1,6',
        // },
    ],
}
